import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmSealVO {
  id?: number
  reason: string
  fileName: string
  copies: number
  caseId?: number
  firmCaseNo?: string
  caseTitle?: string
  contractId?: number
  contractTitle?: string
  status?: string
  applicantUserId?: number
  submitTime?: string
  approverUserId?: number
  approveTime?: string
  approveRemark?: string
  usedTime?: string
  handlerUserId?: number
  scanFileUrl?: string
  voidReason?: string
  remark?: string
  createTime?: string
}

export interface FirmSealPageReq extends PageParam {
  caseId?: number
  status?: string
  fileName?: string
}

export const FirmSealApi = {
  create: (data: FirmSealVO) =>
    request.post({ url: '/lawyer/firm/admin/seal/create', data }),
  update: (data: FirmSealVO) =>
    request.put({ url: '/lawyer/firm/admin/seal/update', data }),
  delete: (id: number) =>
    request.delete({ url: '/lawyer/firm/admin/seal/delete?id=' + id }),
  get: (id: number) =>
    request.get<FirmSealVO>({ url: '/lawyer/firm/admin/seal/get?id=' + id }),
  page: (params: FirmSealPageReq) =>
    request.get<PageResult<FirmSealVO>>({ url: '/lawyer/firm/admin/seal/page', params }),
  submit: (id: number) =>
    request.put({ url: '/lawyer/firm/admin/seal/submit?id=' + id }),
  approve: (data: { id: number; approved: boolean; remark?: string }) =>
    request.put({ url: '/lawyer/firm/admin/seal/approve', data }),
  confirmUse: (data: { id: number; scanFileUrl?: string; remark?: string }) =>
    request.put({ url: '/lawyer/firm/admin/seal/confirm-use', data }),
  void: (data: { id: number; voidReason?: string }) =>
    request.put({ url: '/lawyer/firm/admin/seal/void', data })
}

export const SEAL_STATUS_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'PENDING', label: '待审批' },
  { value: 'APPROVED', label: '已通过' },
  { value: 'REJECTED', label: '已驳回' },
  { value: 'USED', label: '已用印' },
  { value: 'VOID', label: '已作废' }
]

export const sealStatusLabel = (status?: string) =>
  SEAL_STATUS_OPTIONS.find((o) => o.value === status)?.label || status || '-'
